import React, { useState } from 'react';

const POSTS = [
  {
    slug: 'rag-enterprise',
    cat: 'AI Engineering',
    catColor: '#00B14F',
    catBg: 'rgba(0,177,79,.1)',
    date: 'Feb 2026',
    readTime: '8 min read',
    title: 'Building Production-Ready RAG Systems for Indian Enterprises',
    excerpt: 'Retrieval-Augmented Generation sounds simple until you hit real data: messy PDFs, Tamil/Hindi text, 10GB+ knowledge bases. Here\'s our battle-tested architecture.',
    tags: ['LangChain', 'RAG', 'Azure', 'OpenAI'],
    icon: '🤖',
  },
  {
    slug: 'azure-cost-cut',
    cat: 'Cloud',
    catColor: '#2563EB',
    catBg: 'rgba(59,130,246,.1)',
    date: 'Jan 2026',
    readTime: '6 min read',
    title: 'How We Cut Azure Costs by 38% Without Touching a Single Feature',
    excerpt: 'Most Azure bills are 30–50% waste. Reserved instances, right-sizing, auto-shutdown schedules, and Spot VMs for dev environments — here\'s the exact playbook.',
    tags: ['Azure', 'FinOps', 'Terraform', 'Cost'],
    icon: '☁️',
  },
  {
    slug: 'flutter-production',
    cat: 'Mobile',
    catColor: '#D97706',
    catBg: 'rgba(245,158,11,.1)',
    date: 'Dec 2025',
    readTime: '10 min read',
    title: 'Flutter in Production: What Nobody Tells You About App Store Submissions',
    excerpt: 'We\'ve shipped 12+ Flutter apps to production. The code is the easy part — provisioning profiles, deep links, background sync, and Play Store review rejections are where teams fail.',
    tags: ['Flutter', 'iOS', 'Android', 'CI/CD'],
    icon: '📱',
  },
  {
    slug: 'dotnet-microservices',
    cat: 'Architecture',
    catColor: '#7C3AED',
    catBg: 'rgba(124,58,237,.1)',
    date: 'Nov 2025',
    readTime: '12 min read',
    title: 'Microservices with .NET 8: When to Break the Monolith (and When Not To)',
    excerpt: 'Most teams reach for microservices too early. We\'ve migrated 4 monoliths and built 3 from scratch as microservices. Here\'s the decision framework we use.',
    tags: ['.NET 8', 'Microservices', 'Architecture', 'gRPC'],
    icon: '🔧',
  },
  {
    slug: 'devsecops-pipeline',
    cat: 'DevSecOps',
    catColor: '#0891B2',
    catBg: 'rgba(6,182,212,.1)',
    date: 'Oct 2025',
    readTime: '7 min read',
    title: 'Zero-Trust CI/CD: Security Gates That Don\'t Slow Your Team Down',
    excerpt: 'Security scanning that takes 45 minutes kills adoption. We\'ll show you a parallel pipeline architecture with SonarQube + Trivy + OWASP ZAP that adds under 4 minutes.',
    tags: ['DevSecOps', 'GitHub Actions', 'Docker', 'OWASP'],
    icon: '🔐',
  },
  {
    slug: 'langchain-agents',
    cat: 'AI Engineering',
    catColor: '#00B14F',
    catBg: 'rgba(0,177,79,.1)',
    date: 'Sep 2025',
    readTime: '9 min read',
    title: 'LangChain Agents in 2025: From Toy Demos to Real Automation',
    excerpt: 'Tool calling, memory management, parallel agent execution, and error recovery — the gap between a demo agent and a production agent is enormous. Here\'s how we bridge it.',
    tags: ['LangChain', 'Agents', 'OpenAI', 'Python'],
    icon: '🦜',
  },
];

const ALL_CATS = ['All', ...new Set(POSTS.map(p => p.cat))];

export default function BlogPreview() {
  const [filter, setFilter] = useState('All');
  const visible = filter === 'All' ? POSTS : POSTS.filter(p => p.cat === filter);

  return (
    <section className="blog-sec" id="blog" aria-label="Technical blog">
      <div className="wrap">
        <div className="blog-header rv">
          <div>
            <div className="chip" style={{ marginBottom: '.75rem' }}>✍️ Engineering Blog</div>
            <h2>Knowledge We Actually Share</h2>
            <p>Deep-dive technical guides from our engineers — no fluff, no SEO padding.</p>
          </div>
          <a
            href="https://wa.me/918123629993?text=I'd like to be notified of new blog posts from JSDevBrains"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-g"
          >
            🔔 Subscribe
          </a>
        </div>

        {/* Filters */}
        <div className="blog-filters rv">
          {ALL_CATS.map(cat => (
            <button
              key={cat}
              className={`nf ${filter === cat ? 'on' : ''}`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="blog-grid">
          {visible.map((post, i) => (
            <article key={post.slug} className={`blog-card rv`} style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="blog-card-top">
                <span className="blog-icon">{post.icon}</span>
                <div className="blog-meta">
                  <span className="nc-cat" style={{ background: post.catBg, color: post.catColor }}>{post.cat}</span>
                  <span className="blog-read">{post.readTime}</span>
                </div>
              </div>
              <div className="blog-date">{post.date}</div>
              <h3 className="blog-title">{post.title}</h3>
              <p className="blog-excerpt">{post.excerpt}</p>
              <div className="blog-tags">
                {post.tags.map(t => (
                  <span key={t} className="blog-tag">{t}</span>
                ))}
              </div>
              <div className="blog-footer">
                <a
                  href={`https://wa.me/918123629993?text=I read your article "${post.title}" and have a question`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blog-cta"
                >
                  Read full article → 
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
